import { Controller } from '@hotwired/stimulus';

import { apply } from '@/modules/mask';

export default class extends Controller {
  connect() {
    apply(this.element, { lazy: true, mask: '00000-000' });
  }
}
